module.exports = __webpack_public_path__ + "img/MC.b0ee4d81.svg";